import BaseAPI from "../base";

class TeamService extends BaseAPI {
  // 机构渠道
  channels(params) {
    return this.post({
      url: "/YuanHe/Team/Channels",
      data: params,
    });
  }
  // 日历
  calendar(params) {
    return this.post({
      url: "/YuanHe/Team/Calendar",
      data: params,
    });
  }
  // 预约编辑
  bookingEdit(params) {
    return this.post({
      url: "/YuanHe/Team/BookingEdit",
      data: params,
    });
  }
  // 预约信息
  bookingInfo(params) {
    return this.post({
      url: "/YuanHe/Team/BookingInfo",
      data: params,
    });
  }
  // 审批预约信息
  bookingAudit(params) {
    return this.post({
      url: "/YuanHe/Team/BookingAudit",
      data: params,
    });
  }
}

export default new TeamService();
